/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of DefaultExtraH5PluginsPublisher
 */

import PositionPlugin from 'com/didichuxing/plugins/defaultextra/PositionPlugin';
import OMGH5PageLeavePlugin from 'com/didichuxing/tracker/h5/plugins/h5/OMGH5PageLeavePlugin';
import OMGH5ClickPlugin from 'com/didichuxing/tracker/h5/plugins/h5/OMGH5ClickPlugin';
import OMGH5ReceivedPlugin from 'com/didichuxing/tracker/h5/plugins/h5/OMGH5ReceivedPlugin';
import OMGH5CustomPlugin from 'com/didichuxing/tracker/h5/plugins/h5/OMGH5CustomPlugin';
import OMGH5JsErrorPlugin from 'com/didichuxing/tracker/h5/plugins/h5/OMGH5JsErrorPlugin';
import OMGH5PageViewPlugin from 'com/didichuxing/tracker/h5/plugins/h5/OMGH5PageViewPlugin';
import OMGH5ErrorPlugin from 'com/didichuxing/tracker/h5/plugins/h5/OMGH5ErrorPlugin';
import OMGH5PerformancePlugin from 'com/didichuxing/tracker/h5/plugins/h5/OMGH5PerformancePlugin';
// import OMGSafeTypingPlugin from 'com/didichuxing/tracker/h5/plugins/h5/OMGSafeTypingPlugin';

export default [
    PositionPlugin,
    OMGH5PageLeavePlugin,
    OMGH5ClickPlugin,
    OMGH5ReceivedPlugin,
    OMGH5CustomPlugin,
    OMGH5JsErrorPlugin,
    OMGH5PageViewPlugin,
    OMGH5ErrorPlugin,
    OMGH5PerformancePlugin
    // OMGSafeTypingPlugin
];

/*
function encodeHash(str: string): number {
    let hash: number = 1315423911;
    for (let i: number = 0, j: number = str.length; i < j; ++i) {
        hash ^= ((hash << 5) + str.charCodeAt(i) + (hash >> 2));
    }
    return hash & 0x7FFFFFFF;
}

function uploadSpec(g: any, NAME_POINT: string, URL_POINT: string) {
    console.log(`[${ NAME_POINT }]: ${ URL_POINT } loaded`);
    try {
        // 如果是 webapp 5.0
        const instNames = Object.keys(g).filter(
            (key) => key.includes('__OMG_INSTANTIATION') &&
                (g)[key].context.appKey === 'omega3b0d3e7e46' // 'omega3b0d3e7e46' // holmes-web
        );
        if (instNames.length > 0) {
            console.log(`[${ NAME_POINT }]: 命中 ak`);
            const OmgInst: any = (g)[instNames[0]];
            const oc = OmgInst.context;
            const URL = `//${ oc.uploadHost }${ '/api/web/stat' }`; // `//omgup.xiaojukeji.com/api/web/stat`;

            const files: any = g.performance.getEntries().filter((it: any) => it.name.indexOf(URL_POINT) > -1);
            const duration = files.length > 0 ? files[0].duration : -1;

            const xhr = new XMLHttpRequest();
            xhr.timeout = oc.timeout || 1500;
            xhr.ontimeout = () => {
                console.log(`[${ NAME_POINT }]: Omega POST Timeout`);
                // reject(new TimeoutEvent(event.getType(), event.getData().attrs || {}, this.getContext()));
            };
            xhr.open('POST', URL);
            // ak=omega3b0d3e7e46&e=OMGJsMonitorConfig&  OMGJsMonitorPlugin
            const data: any = {
                ak: oc.appKey,
                an: 'Others',
                attrs: {
                    jv: oc.version,
                    omgJsDuration: duration
                },
                e: NAME_POINT,
                fr: 'h5',
                oid: oc.openid || oc.omgId,
                ot: oc.osType,
                ov: oc.osVersion,
                seq: '0',
                ts: new Date().getTime(),
                v: oc.url,
                ua: oc.userAgent,
                uo: oc.utcOffset,
                uwid: oc.viewportId
                // tk: encodeHash
            };
            let newData: any = Object.assign({}, data);
            newData.attrs = JSON.stringify(data.attrs);
            newData = Object.keys(newData).map((key) => `${ key }=${ encodeURIComponent(newData[key]) }`).join('&');
            newData = newData + `&tk=${ encodeHash(newData) }`;
            xhr.send(newData);
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);
                    if (response.state && response.state.code !== 200) {
                        if (response.state.code === 500) {
                            console.log(
                                `[${ NAME_POINT }]: error code=${ response.state.code }, msg=${ response.state.msg }`);
                            // this.errorreportedEvents.add(event);
                        }
                        // GlobalUtil.dispatchOmgLog(`POST 200 上报错误${event.getType()}_
                        //     ${response.state.code || 0}_${response.state.msg || ''}`);
                    }
                    // ReportCallbackUtil.reportCallback(response);
                    // resolve(event);
                    console.log(`[${ NAME_POINT }]: done`);
                }
            };
            xhr.onerror = () => {
                console.log(`[${ NAME_POINT }]: onerror`);
                if (xhr.status === 500) {
                    // this.errorreportedEvents.add(event);
                } else {
                    // console.error('POST上报失败onerror' + xhr.status);
                }
                // reject(new FailedEvent(new Error('POST Error'), event.getType(),
                //     event.getData().attrs || {}, this.getContext()));
            };

            console.log(`[${ NAME_POINT }]: 发出请求`);
        }
    } catch (error) {
        console.log(`[${ NAME_POINT }]: warn`);
        console.warn(error);
    }
}

const gw = window as any;
if (gw) {
    const NAME_POINT = 'OMGJsMonitorPlugin';
    const URL_POINT = 'omega.default.extra.plugins.min.js';
    uploadSpec(gw, NAME_POINT, URL_POINT);
}
*/
